<template>
  <div :class="{ white: white }">
    <div class="wrapper">
      <img
        class="image-popUpLeft"
        :class="{
          whiteBG:
            pageName === 'onderstromen' ||
            pageName === 'overtuigingsstrategieën',
        }"
        :src="popupContent.image"
      />
      <div v-if="white" class="text">
        <p v-if="pageName === 'archetypen'" class="body">
          {{ $t("components.significant") }}
          <b>{{ popupContent.topic.toLowerCase() }}</b>
          {{ $t("components.vertegenwoordigd") }}
        </p>
      </div>
    </div>
    <p class="title">{{ popupContent.title }}</p>
    <p class="body">{{ popupContent.description }}</p>
    <p class="body">{{ popupContent.tags }}</p>
  </div>
</template>

<script>
// export default {
//   props: {
//     popupContent: Object,
//     white: {
//       type: Boolean,
//       default: false,
//     },
//   },
//   data() {
//     return {
//       pageName: this.$route.path.substring(
//         this.$route.path.lastIndexOf("/") + 1
//       ),
//     };
//   },
// };

import { ref, computed, defineComponent } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  props: {
    popupContent: {
      type: Object,
      required: true,
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const route = useRoute();
    const pageName = computed(() => {
      return route.path.substring(route.path.lastIndexOf("/") + 1);
    });

    return {
      pageName,
    };
  },
});
</script>

<style lang="sass" scoped>
.green
  background: linear-gradient(270deg, #3FBEB1 0%, #009987 100%)
.purple
  background: linear-gradient(90deg, #964380 0%, #BE78AB 100%)
.white
  .text
    display: flex
    flex-direction: column
    justify-content: center
    width: 134px
    .perc
      margin-top: 17px
      margin-bottom: 7px
      width: 55px
      border-radius: 17.5px
      color: white
      font-size: 18px
      line-height: 38px
      text-align: center
    .body
      margin: 0
      font-size: 15px
      line-height: 25px
      padding: 0
.wrapper
  direction: ltr
  display: flex
  .image-popUpLeft
    border-radius: 10px
    height: 120px
    width: 127px
    margin-bottom: 12px
    margin-right: 19px
    &.whiteBG
      background-color: $white
p
  margin: 0
  direction: ltr
  padding-right: 30px
.title
  font-size: 28px
  line-height: 38px
  margin-bottom: 20px
.body
  font-size: 15px
  line-height: 22px
  margin-bottom: 10px
  &:last-child
   margin-bottom: 0px
</style>
